import { Node, mergeAttributes } from '@tiptap/core'

export default Node.create({
    name: "videoEmbed",
    group: "block",
    draggable: true,
    addAttributes() {
        return {
            type: {
                default: "youtube"
            },
            identifier: {
                default: undefined,
                renderHTML: attributes => {
                    if (attributes.type === "youtube") {
                        return {
                            src: "https://www.youtube.com/embed/" + attributes.identifier,
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowfullscreen: true,
                            frameborder: 0
                        }
                    }
                }
            },
            size: {
                default: 350,
                renderHTML: attributes => {
                    if (attributes.size) {
                        return {
                            width: (attributes.size * attributes.aspectRatio) + "px",
                            height: attributes.size + "px",
                        }
                    }
                }
            },
            aspectRatio: {
                default: 16/9
            }
        }
    },
    renderHTML({ HTMLAttributes }) {
        return [["div"], { style: HTMLAttributes.style ?? "" }, ["iframe", mergeAttributes(HTMLAttributes, { class: "d-inline-block", style: "max-width: 100%" })]];
    },
    addCommands() {
        return {
            setVideoEmbed: options => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options
                });
            },
            setVideoEmbedSize: (size) => ({ commands }) => {
                let attributes = JSON.parse(JSON.stringify(this.editor.getAttributes('videoEmbed')));
                attributes.size = size;
                return commands.updateAttributes("videoEmbed", attributes);
            },
            setVideoEmbedAspectRatio: (ratio) => ({ commands }) => {
                let attributes = JSON.parse(JSON.stringify(this.editor.getAttributes('videoEmbed')));
                attributes.aspectRatio = ratio;
                return commands.updateAttributes("videoEmbed", attributes);
            }
        }
    }
});